import { AccountMappingAccountItem, IAccount } from '@modeso/types__aumico-lib-annualreport-be';
import { IAccountWithRatio } from '../../interfaces/IAccountWithRatio.interface';

export function isAccount(item: AccountMappingAccountItem): item is IAccount {
    return 'accountNumber' in item;
}
export function isAccountWithRatio(item: AccountMappingAccountItem | IAccountWithRatio): item is IAccountWithRatio {
    return 'closingRatioValue' in item;
}
